// extracted by mini-css-extract-plugin
export default {"heading":"SessionExpired_heading__coeX4","forwardButton":"SessionExpired_forwardButton__Pl0VX"};